import { backendGetRequest } from "../../helpers/callBackend";
import { errorMessage } from "../../helpers/errorMessageFunc";
import { message } from "antd";

export async function getVerificationToken(bankAccountId){
    var verificationToken = await backendGetRequest(
        "/api/unit/verification-token/",
        { params: { bank_account_id: bankAccountId } },
        "loading"
    );

    if (verificationToken.status == 200) {
      message.success("Text sent to your phone")
    } else {
      errorMessage("Error generating code for your payments.")
    }

    return verificationToken?.data?.token;
}

export const generateOtp = async () => {
  try {
    const otpResp = await backendGetRequest('/api/payments/send-otp')

    message.success(otpResp.data?.description)
  } catch (error) {
    errorMessage(`Error when trying to generate code: ${error}`)
  }
}
